import { Link } from "react-router-dom";

const stats = [
  { value: "1200+", label: "累计资讯收录" },
  { value: "3 大", label: "核心内容分类" },
  { value: "每日", label: "资讯实时更新" },
  { value: "10 万+", label: "影迷共同关注" },
];

export default function SiteIntro() {
  return (
    <section className="border-t border-background-200/70 bg-background-100/60">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-16 lg:grid-cols-2 lg:items-center">
        <div>
          <div className="mb-3 flex items-center gap-2">
            <span className="h-3 w-1 rounded-full bg-accent-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              About 羞羞
            </span>
          </div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            你的影视情报站
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            羞羞是面向影视爱好者与娱乐资讯关注者的综合影视娱乐门户。我们聚合电影、电视剧与综艺的资讯报道与作品介绍，
            让每一部值得关注的作品都能被及时看见。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            网站聚焦内容浏览与发现，持续保持信息的权威与及时，帮助你在海量内容中快速定位真正感兴趣的方向。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-search-line" aria-hidden="true" />
              搜索影视资讯
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="font-heading text-3xl font-black text-primary-600">{s.value}</div>
              <div className="mt-2 text-sm text-foreground-500">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}